import React from 'react';
import {
  Typography,
  Box,
} from '@mui/material';

interface OptimizationControlProps {}

const OptimizationControl: React.FC<OptimizationControlProps> = () => {
  return (
    <Box>
      <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
        Information
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Use the export buttons in the top bar to download Excel files and analysis reports after running optimization.
      </Typography>
    </Box>
  );
};

export default OptimizationControl;

